import templateStr from 'text!./templates/wizard-page-actions.html';
import FormUtil from 'edge/platform/modelvalidation/FormUtil';

export default ['StateUtils', '$q', function (StateUtils, $q) {
    return {
        template: templateStr,
        scope: {
            'showCancel': '=?',
            'showPrevious': '=?',
            'showNext': '=?',
            'disableCancel': '=?',
            'disablePrevious': '=?',
            'disableNext': '=?',
            'next': '=?',
            'nextLabel': '@?',
            'nextTooltip': '@?',
            'previous': '=?',
            'previousLabel': '@?',
            'cancel': '=?',
            'cancelLabel': '@?',
            'gwWizardPageActions': '=',
            'flowModel': '=?',
            'hideTopBorder': '=?',
            'nextButtonConfig': '=?',
            'prevButtonConfig': '=?'
        },
        require: ['?^form', '?^ngForm'],
        link: function link(scope, element, attrs, formCtrls) {
            var formCtrl = formCtrls[0] || {};
            var flowModel = scope.flowModel || StateUtils.activeDataForState(true).flowModel;
            var model = scope.gwWizardPageActions || StateUtils.activeDataForState(true).model;
            if (!flowModel) {
                throw new Error('Page action directive under a wizard state that has a flowModel data property');
            }

            scope.showNext = scope.showNext !== undefined ? scope.showNext : true;
            if (flowModel.steps.length > 0) {
                var isFirstStep = flowModel.steps[0].name === flowModel.currentStep.name;
                scope.showPrevious = scope.showPrevious !== undefined ? scope.showPrevious : !isFirstStep;
            }
            scope.showCancel = scope.showCancel !== undefined ? scope.showCancel : true;

            scope.disableCancel = scope.disableCancel || false;
            scope.disablePrevious = scope.disablePrevious || false;

            scope.goToNext = function () {
                FormUtil.markFormsSubmitted(formCtrl);
                if (scope.next) {
                    var actionDeferred = $q.defer();
                    scope.actionPromise = actionDeferred.promise;
                    scope.next(function (_model, args) {
                        if (!_model) {
                            actionDeferred.reject();
                        } else {
                            actionDeferred.resolve();
                            flowModel.next(_model, args);
                        }
                        scope.actionPromise = undefined;
                    }, formCtrl);
                } else {
                    flowModel.next(model);
                }
            };
            scope.goToPrevious = function () {
                if (scope.previous) {
                    var actionDeferred = $q.defer();
                    scope.actionPromise = actionDeferred.promise;
                    scope.previous(function (_model, args) {
                        actionDeferred.resolve();
                        flowModel.previous(_model, args);
                    }, formCtrl);
                } else {
                    flowModel.previous(model);
                }
            };
            scope.goToCancel = function () {
                if (scope.cancel) {
                    var actionDeferred = $q.defer();
                    scope.actionPromise = actionDeferred.promise;
                    scope.cancel(function (_model, args) {
                        if (!_model) {
                            actionDeferred.reject();
                        } else {
                            actionDeferred.resolve();
                            args = args || {};
                            args.visitedSteps = flowModel.visitedSteps.map(function (step) {
                                return step.name;
                            });
                            flowModel.cancel(_model, args);
                        }
                        scope.actionPromise = undefined;
                    }, formCtrl);
                } else {
                    var args = {};
                    args.visitedSteps = flowModel.visitedSteps.map(function (step) {
                        return step.name;
                    });
                    flowModel.cancel(model, args);
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/wizard/WizardPageActionsDirective.js
// module id = 791
// module chunks = 0